import { OrderingInitialState } from '@reducers/ordering/types';

export const removeBasketItems = (state: OrderingInitialState): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    menus: [],
  },
});
